import { CamelCaseKeys, NumericString } from '@utils/typescript';
import { UserLess } from '@models/User';

export enum CashFlows {
  Inflow = 'inflow',
  Outflow = 'outflow',
}

export type PolicyCommissionInvoiceList = CamelCaseKeys<{
  id: number;
  cash_flow: CashFlows;
  insurer_paid: boolean;
  frontline_paid: boolean;
  total_premium: NumericString;
  brokerage_percentage: NumericString;
  brokerage_amount: NumericString;
  total_frontline_brokerage_percentage: NumericString;
  total_frontline_brokerage_amount: NumericString;
  created_at: number;
}>;

type FrontlineCommission = CamelCaseKeys<{
  id: number;
  brokerage_percentage: NumericString;
  brokerage_amount: NumericString;
  frontline: UserLess;
}>

export type PolicyCommissionInvoice = PolicyCommissionInvoiceList &
CamelCaseKeys<{
  frontline_commissions: FrontlineCommission[];
}>;
